/**
 * Indicatifs pour sélecteur téléphone (page appel, etc.). Pas une validation libphonenumber complète.
 * `stripLeadingZero` : retirer le 0 initial national avant de préfixer l’indicatif (usage courant EU).
 */
export const PHONE_COUNTRY_OPTIONS = [
  { id: "FR", name: "France", dial: "33", stripLeadingZero: true },
  { id: "BE", name: "Belgique", dial: "32", stripLeadingZero: true },
  { id: "CH", name: "Suisse", dial: "41", stripLeadingZero: true },
  { id: "LU", name: "Luxembourg", dial: "352", stripLeadingZero: false },
  { id: "DE", name: "Allemagne", dial: "49", stripLeadingZero: true },
  { id: "ES", name: "Espagne", dial: "34", stripLeadingZero: true },
  { id: "IT", name: "Italie", dial: "39", stripLeadingZero: true },
  { id: "PT", name: "Portugal", dial: "351", stripLeadingZero: true },
  { id: "NL", name: "Pays-Bas", dial: "31", stripLeadingZero: true },
  { id: "GB", name: "Royaume-Uni", dial: "44", stripLeadingZero: true },
  { id: "IE", name: "Irlande", dial: "353", stripLeadingZero: true },
  { id: "AT", name: "Autriche", dial: "43", stripLeadingZero: true },
  { id: "US", name: "États-Unis", dial: "1", stripLeadingZero: true },
  { id: "CA", name: "Canada", dial: "1", stripLeadingZero: true },
  /** Saisie directe E.164 (+indicatif obligatoire) pour les pays hors liste. */
  { id: "INTL", name: "Autre pays", dial: "", intlOnly: true },
];

export function getPhoneCountryById(id) {
  const hit = PHONE_COUNTRY_OPTIONS.find((x) => x.id === id);
  return hit || PHONE_COUNTRY_OPTIONS[0];
}
